import { CSSProperties, FC } from 'react';
import {
  AccountProject,
  HandleRemoveProjectWithRoles,
} from './permissions-table.types';
import {
  IconButton,
  Stack,
  TableCell,
  TextBody,
  Tooltip,
} from '@pypestream/design-system';
import { useTranslation } from '@pypestream/translations';
import './permissions-table.scss';

export const ProjectNameCell: FC<{
  project: AccountProject;
  handleRemoveProjectWithRoles: HandleRemoveProjectWithRoles;
  canManageAccess: boolean;
}> = ({ project, handleRemoveProjectWithRoles, canManageAccess }) => {
  const [t] = useTranslation();

  const hasInheritedRole = !!project._account_project_roles.find(
    (role) => role.teams
  );

  const iconButton = (
    <IconButton
      name="close"
      size="small"
      disabled={hasInheritedRole}
      onClick={() =>
        handleRemoveProjectWithRoles({
          orgId: project.project.accountId,
          projectId: project.project.id,
        })
      }
    ></IconButton>
  );

  return (
    <TableCell
      rowspan={project.project?.project_product_settings?.length || 1}
      style={{ '--c-table-cell-min-width': '120px' } as CSSProperties}
    >
      <Stack
        direction="row"
        alignItems="center"
        gutter="2xsmall"
        justifyContent="space-between"
        nowrap
      >
        <TextBody variant="secondary" size="small">
          {project?.project.name}
        </TextBody>
        {canManageAccess && (
          <>
            {hasInheritedRole ? (
              <Tooltip
                content={
                  t(
                    'manager/common:permissionAndAccessTable.projectRemoveDisabledTooltip'
                  ) || ''
                }
              >
                {iconButton}
              </Tooltip>
            ) : (
              iconButton
            )}
          </>
        )}
      </Stack>
    </TableCell>
  );
};
